import { VariableLabel } from '@k3/core'
import CircleIcon from '@mui/icons-material/Circle'
import { Box, List, ListItem, ListItemButton, Typography } from '@mui/material'

export const ColorChooser = ({ inputKey, ...props }: any) => {
  const handleChange = (valueId: number, value: any) => {
    props.onChange(valueId)
  }

  return (
    <>
      <VariableLabel variable={props.variable} />
      <Box
        component="div"
        sx={{
          display: 'grid',
          justifyContent: 'start',
          gridTemplateColumns: `repeat(1, 100%)`,
          gridGap: '1px',
          width: 1.0,
          maxHeight: '300px',
          overflowY: 'auto',
          cursor: 'pointer',
        }}
      >
        <List
          dense
          sx={{
            width: '100%',
            maxWidth: 360,
            bgcolor: 'background.paper',
            overflow: 'auto',
          }}
        >
          {props.validValues.map((value: any, key: number) => {
            const active = props.selection.valueId === value.id
            return (
              <ListItem
                key={value.id}
                disablePadding
                onClick={() => handleChange(value.id, value)}
              >
                <ListItemButton
                  sx={{
                    // margin: 0,
                    paddingLeft: 0,
                    borderStyle: 'solid',
                    borderWidth: '2px',
                    borderRadius: '2px',
                    borderColor: (theme) =>
                      active ? theme.palette.primary.main : 'transparent',
                    margin: 0.2,
                  }}
                >
                  <CircleIcon
                    sx={{
                      color: `${value.value}`,
                      fontSize: 50,
                    }}
                  ></CircleIcon>
                  <Typography sx={{ marginLeft: 2 }}>{value.label}</Typography>
                </ListItemButton>
              </ListItem>
            )
          })}
        </List>
      </Box>
    </>
  )
}
